import React, { useContext, useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import OwnerType from '../../TractComponents/OwnerType';
import useFetch from 'use-http';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import IOwner from 'src/models/IOwner';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';

interface IConvertOwnerDialogProps {
    ownerLookupId: number;
    ownerType: string;

    onConvert: () => void;
    onCloseDialog?: () => void;
}

// add owner types
const ownerTypes = [
    { value: OwnerType.Individual, label: 'Individual' },
    { value: OwnerType.Trust, label: 'Trust' },
    { value: OwnerType.Business, label: 'Business' },
    { value: OwnerType.GovBLM, label: 'Gov-BLM' },
    { value: OwnerType.GovRAL, label: 'Gov-RAL' },
    { value: OwnerType.GovSTATE, label: 'Gov-STATE' }
];

const ConvertOwnerDialog = (props: IConvertOwnerDialogProps) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const { get, post, response } = useFetch();
    
    const [selectedType, setSelectedType] = useState<number>(-1);
    const [convertOwner, setConvertOwner] = useState<AddOwner>(undefined);

    useEffect(() => {
        getOwnerInfo();
    }, []);

    const getOwnerInfo = async () => {
        if (props.ownerLookupId > 0) {
            const result: IOwner = await get(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/${props.ownerLookupId}`);

            if (response.ok) {
                handleOwnerInfo(result);
            } else {
                window.alert('Unable to retrieve Owner Data!');
                props.onCloseDialog();
            }
        }
    };

    const onConvertOwner = async () => {
        if (selectedType > -1) {
            await post(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/${props.ownerLookupId}/convert/${selectedType}`, convertOwner);

            if (response.ok) {
                props.onConvert();
                props.onCloseDialog();
            } else {
                window.alert('Unable to Convert Owner!');
            }
        }
    };

    const handleOwnerInfo = (owner: IOwner) => {
        let ownerInfo = new AddOwner;
        ownerInfo.ownerType = ownerTypes.find(ot => ot.label === props.ownerType)?.value;

        switch (ownerInfo.ownerType) {
            case 0:
                ownerInfo.individualOwner = owner as OwnerIndividual;
                break;
            case 1:
                ownerInfo.ownerTrust = owner as OwnerTrust;
                break;
            case 2:
                ownerInfo.businessOwner = owner as OwnerBusiness;
                break;
            case 3:
                ownerInfo.bolmOwner = owner as OwnerBOLM;
                break;
            case 4:
                ownerInfo.ralOwner = owner as OwnerRAL;
                break;
            case 5:
                ownerInfo.stateLandOwner = owner as OwnerStateLand;
                break;
            default:
                break;
        }

        setConvertOwner(ownerInfo);
    };

    return (
        <Dialog title="Convert Owner">
            <div style={{ width: '35vw' }}>
                <div style={{ textAlign: 'center', fontSize: '1.5rem' }} className="mb-2">
                    WARNING: Converting to a different owner type may result in a loss of incompatible data.
                </div>
                <RHFSelect
                    style={{ width: '100%' }}
                    name="ownerType"
                    label="New Owner Type"
                    options={ownerTypes}
                    onChange={(e) => setSelectedType(parseInt(e.currentTarget.value, 10))}
                />
                <div className="mt-2" style={{ textAlign: 'center' }}>
                    <Button text="Confirm" onClick={onConvertOwner} className="mr-2" intent="primary" disabled={selectedType === -1} />
                    <Button text="Cancel" onClick={props.onCloseDialog} intent="danger" />
                </div>
            </div>
        </Dialog>
    );
};

export default ConvertOwnerDialog;


// WEBPACK FOOTER //
// ./src/components/project/sections/tract/dialogs/ConvertOwnerDialog.tsx